export const ArrowRightSVG = () => {
  return (
    <svg
      className="scale-125"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.625 21.75C12.4583 21.75 12.3008 21.685 12.1833 21.5667C11.94 21.3233 11.94 20.9267 12.1833 20.6825L19.8667 12.9992H2.625C2.28 13 2 12.72 2 12.375C2 12.03 2.28 11.75 2.625 11.75H19.8658L12.1825 4.06667C12.065 3.94917 12 3.79167 12 3.625C12 3.45833 12.065 3.30083 12.1833 3.18333C12.3008 3.065 12.4583 3 12.625 3C12.7917 3 12.9492 3.065 13.0667 3.18333L21.8167 11.9333C21.875 11.9917 21.9208 12.06 21.9525 12.1375C21.955 12.1442 21.9583 12.1517 21.9608 12.1592C21.9867 12.2267 22 12.3008 22 12.375C22 12.4475 21.9867 12.52 21.9608 12.59C21.9592 12.595 21.9575 12.5992 21.9558 12.6033C21.9208 12.69 21.8742 12.7592 21.8158 12.8175L13.0667 21.5667C12.9492 21.685 12.7917 21.75 12.625 21.75Z"
        fill="#3C4D6A"
      />
    </svg>
  );
};
